import { render, staticRenderFns } from "./commissionSetLevel3.vue?vue&type=template&id=298d70a6&scoped=true"
import script from "./commissionSetLevel3.vue?vue&type=script&lang=js"
export * from "./commissionSetLevel3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298d70a6",
  null
  
)

export default component.exports